const forms = Array.from(document.querySelectorAll(".js-shortlist"));

export function init() {
	forms.forEach((form) => create(form));
}

export function create(element) {
	element.addEventListener("submit", handleSubmit);
}

function handleSubmit(event) {
	const formData = new FormData(event.target);

	const options = {
		method: "post",
		body: formData,
		headers: { Accept: "application/json" },
	};

	fetch("/", options)
		.then((response) => response.json())
		.then((data) =>
			data.items.forEach((item) => {
				let id = item.elementId;
				let added = item.action === "added";

				let selector = `[data-shortlist-id="${id}"]`;
				let buttons = Array.from(document.querySelectorAll(selector));

				buttons.forEach((element) =>
					element.classList.toggle("is-saved", added),
				);
			}),
		);

	event.preventDefault();
}
